<template lang="html">
  <div
    class="login-dropdown-wrapper"
    :class="{ modStyle: modalDrop }"
    v-click-outside="onClickOutside"
  >
    <div @click="focusInput()" class="link">
      <!-- <div @mouseover="dropdown = true" @click="dropdown = true" class="link-img">
        <img src="@/assets/icons/userIcon.png" alt="user-icon">
      </div> -->
      <div
        v-if="!modalDrop"
        @mouseover="dropdown = true"
        @click="dropdown = true"
        class="link-text"
      >
        {{ $t("main.login") }}
      </div>
    </div>
    <div v-if="dropdown || modalDrop" class="dropdown-wrapper">
      <div class="dropdown">
        <input
          @keyup.enter="login()"
          v-model="user.username"
          ref="usernameInput"
          type="text"
          :placeholder="$t('main.usernameOrEmail')"
          class="regular-input"
        />
        <input
          @keyup.enter="login()"
          v-model="user.password"
          type="password"
          :placeholder="$t('main.password')"
          class="regular-input no-margin"
        />
        <router-link class="fpass" :to="{ name: 'ForgotPassword' }">
          <div @click="closeDropdown()" class="forgot-password">
            {{ $t("main.forgotPassword") }}?
          </div>
        </router-link>
        <div v-google-signin-button="clientId" class="btn-google btn">
          <img src="@/assets/icons/google-img.png" alt="google-logo" />
          <span v-html="$t('main.googleLogin')"></span>
        </div>
        <!-- <div class="btn-facebook btn">
          <img src="@/assets/icons/facebook-img.png" alt="google-logo">
          <span v-html="$t('main.facebookLogin')"></span>
        </div> -->
        <TurnStile :resetToken="resetToken" @set-token="setToken" />
        <div class="btn-wrapper">
          <div @click="login()" class="btn-login btn">
            {{ $t("main.login") }}
          </div>
          <!-- <div class="btn-registration btn" @click="openModal()">{{$t('main.registration')}}</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
import eventBus from "@/shared/eventBus.js";
import GoogleSignInButton from "vue-google-signin-button-directive";
import TurnStile from "@/components/TurnStileVue2.vue";

export default {
  name: "loginDropdown",
  directives: {
    GoogleSignInButton
  },
  components: {
    TurnStile
  },
  props: {
    modalDrop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dropdown: false,
      // dropdown: true,
      user: {
        username: "",
        password: ""
      },
      localToken: "",
      resetToken: false,
      clientId:
        "604246442681-m9mujciv4kk2tgeh8nrc7vngbcoaprjj.apps.googleusercontent.com"
    };
  },
  methods: {
    closeDropdown() {
      this.dropdown = false;
      eventBus.$emit("closeModal");
    },
    OnGoogleAuthSuccess(idToken) {
      const params = {
        token: idToken
      };
      api
        .googleLogin(params)
        .then(res => {
          localStorage.setItem("sid", res.data.sid);
          this.$emit("changeLoged", true);
          localStorage.setItem("userName", res.data.usr_name);
          this.$store.commit("setUserName", res.data.usr_name);
          if (res.data.admin && res.data.admin === true) {
            this.$store.commit("setUserAdmin", true);
          } else {
            this.$store.commit("setUserAdmin", false);
          }
          eventBus.$emit("openWSConnection");
          this.$toast.success(this.$t("toast.loginSuccess"), {
            duration: 8000
          });
          eventBus.$emit("refresh");
          this.$store.commit("changeFavoritesLength");
          if (
            this.$route.name === "VerificationDisplay" ||
            this.$route.name === "ForgotPassword" ||
            this.$route.name === "Verification"
          ) {
            this.$router.push({ name: "Home" });
          }
        })
        .catch(e => {
          this.$toast.error(this.$t("toast.loginError"), {
            duration: 8000
          });
        });
      // Receive the idToken and make your magic with the backend
    },
    OnGoogleAuthFail(error) {
      console.log(error);
    },
    async login() {
      // await this.$recaptchaLoaded();
      // let token = await this.$recaptcha("login");

      const params = {
        token: this.localToken,
        usr_username: this.user.username,
        usr_password: this.user.password
      };
      // get a new token for the next call
      this.resetToken = !this.resetToken;

      api
        .login(params)
        .then(res => {
          localStorage.setItem("sid", res.data.sid);
          this.$emit("changeLoged", true);
          localStorage.setItem("userName", res.data.usr_name);
          this.$store.commit("setUserName", res.data.usr_name);
          if (res.data.admin && res.data.admin === true) {
            this.$store.commit("setUserAdmin", true);
          } else {
            this.$store.commit("setUserAdmin", false);
          }
          eventBus.$emit("openWSConnection");
          this.$toast.success(this.$t("toast.loginSuccess"), {
            duration: 8000
          });
          eventBus.$emit("refresh");
          this.$store.commit("changeFavoritesLength");
          if (
            this.$route.name === "VerificationDisplay" ||
            this.$route.name === "ForgotPassword" ||
            this.$route.name === "Verification"
          ) {
            this.$router.push({ name: "Home" });
          }
        })
        .catch(e => {
          if (e.response.data.status === "verify") {
            this.$router.push({
              name: "Verification",
              params: { usr_name: this.user.username }
            });
            this.dropdown = false;
          } else if (e.response.data.status === "username") {
            this.$toast.error(this.$t("toast.loginErrorUsername"), {
              duration: 8000
            });
          } else if (e.response.data.status === "password") {
            this.$toast.error(this.$t("toast.loginErrorPassword"), {
              duration: 8000
            });
          } else {
            this.$toast.error(this.$t("toast.loginError"), {
              duration: 8000
            });
          }
        });
    },
    focusInput() {
      this.$refs.usernameInput.focus();
    },
    onClickOutside() {
      this.dropdown = false;
    },
    setToken(e) {
      this.localToken = e;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/inputStyles.scss";
@import "@/assets/scss/btnStyles.scss";
.login-dropdown-wrapper {
  height: 100%;
  line-height: 100%;
  position: relative;
  margin-right: 35px;

  .link {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .link-img {
      margin-right: 10px;
      cursor: pointer;
    }
    .link-text {
      cursor: pointer;
      font-style: normal;
      font-weight: bold;
      font-size: 13px;
      line-height: 21px;
      letter-spacing: 0.02em;
      transition-duration: 0.2s;
      color: $text-color;
    }
  }
  .link:hover .link-text {
    color: $text-hover-color;
  }
  .dropdown-wrapper {
    padding: 100px;
    padding-top: 11px;
    padding-right: 10px;
    position: absolute;
    top: 23px;
    right: -10px;
    z-index: 3;
  }
  .dropdown {
    background-color: white;
    padding: 29px;
    padding-bottom: 26px;
    right: 0px;
    border: 1px solid #ddd;
    z-index: 2;
    width: calc(252px - 58px);
    display: flex;
    flex-direction: column;

    .regular-input {
      margin-bottom: 25px;
    }
    .regular-input.no-margin {
      margin-bottom: 12px;
    }

    .fpass {
      text-decoration: none;
    }

    .forgot-password {
      width: 100%;
      text-align: right;
      margin-bottom: 31px;
      font-family: Ubuntu;
      font-style: italic;
      font-weight: normal;
      font-size: 10px;
      line-height: 11px;
      cursor: pointer;

      color: $main-color;
    }
    .btn-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .btn-login {
        width: 100%;
      }
    }
    .btn {
      span {
        min-width: 140px;
      }
    }
  }
}
.small-nav-wrapper {
  .link {
    .link-text {
      color: white !important;
      margin-bottom: 20px;
      margin-right: 0px;
      font-size: 15px;
    }
  }
  .dropdown-wrapper {
    padding: 10px;
    padding-left: 0px;
    left: -14px;
    right: auto;
  }
}
.modStyle {
  margin-right: 0px !important;
  margin: 0 auto;
  /*  display:flex !important;
    justify-content: center;
    align-items: center;
*/
  .dropdown-wrapper {
    box-sizing: border-box;
    width: 100%;
    margin: 0 auto !important;
    padding: 10px;
  }

  .dropdown {
    border: transparent;
  }
}
</style>
